export default __webpack_public_path__ + "static/media/024-rugby ball.24cb2377.svg";